import { incrementCounter } from './counters';

const KEY = 'fourInARowStats';
const EMPTY = { played: 0, human: 0, ai: 0, draws: 0 };

export function readGameStats() {
  try {
    return { ...EMPTY, ...JSON.parse(localStorage.getItem(KEY)) };
  } catch {
    return { ...EMPTY };
  }
}

// winner: 'Red' (AI), 'Yellow' (human), or null (draw)
export function recordGameResult(winner) {
  const stats = readGameStats();
  stats.played += 1;
  if (winner === 'Red') stats.ai += 1;
  else if (winner === 'Yellow') stats.human += 1;
  else stats.draws += 1;
  incrementCounter('games-played');
  incrementCounter(`games-${winner === 'Red' ? 'ai' : winner === 'Yellow' ? 'human' : 'draws'}`);
  try {
    localStorage.setItem(KEY, JSON.stringify(stats));
  } catch {
    // storage unavailable (private mode etc.) — stats just don't persist
  }
}
